import { useCallback } from 'react'

/**
 * Wraps a real handler so it no-ops in sandbox mode instead of firing — used for drawer
 * actions (New Invoice, New Receipt, manual payment) that lead to real, unmocked side
 * effects outside the sandbox's scope.
 */
export const useSandboxGuardedHandler = <Args extends unknown[]>(
  isSandboxMode: boolean,
  handler: (...args: Args) => void,
): ((...args: Args) => void) => {
  return useCallback(
    (...args: Args) => {
      if (isSandboxMode) {
        return
      }

      handler(...args)
    },
    [isSandboxMode, handler],
  )
}
